import { render, staticRenderFns } from "./DistributorRightsAndObligationsInput.vue?vue&type=template&id=22633989&"
import script from "./DistributorRightsAndObligationsInput.vue?vue&type=script&lang=js&"
export * from "./DistributorRightsAndObligationsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/form/DistributorRightsAndObligationsInput.vue
// module id = null
// module chunks = 